define('viewModels/privileged/qm/MessagesRecordingView',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'moment',
    'services/authService',
    'services/loggingService',
    'services/qualityManagementService',
    'services/qm/qualityAuth',
    'services/userService',
    'util/errorCallbackFactory',
    'viewModels/ViewModel',
    'services/qm/qualityBroadcast',
    'viewModels/privileged/qm/util/BroadCastEnum'
], function (ko,
             _,
             Promise,
             moment,
             authService,
             LOG,
             qualityManagementService,
             qualityAuth,
             userService,
             errorCallbackFactory,
             ViewModel,
             qualityBroadcast,
             BroadcastEnum
) {
    'use strict';

    var MessagesRecordingView = ViewModel.extend(function(conversationId, recordingModels, conversationObservable){
        var self = this;

        self.voicemail = ko.observable();
        self.isVoicemail = false;

        // <!-- Need to implement some otherwise unused properties for RecordingView interface
            var readOnlyObservableFalse = self.computed(function () {
                return false;
            });
            self.hasAnnotationText = readOnlyObservableFalse;
            self.hasChat = readOnlyObservableFalse;
            self.hasScreenRecording = readOnlyObservableFalse;
            self.isRecordingAvailable = readOnlyObservableFalse;
            self.isAvailableAudioRecordingWithMissingMedia = readOnlyObservableFalse;
            self.keywordSpots = ko.observableArray();
        // --> end of RecordingView vars

        self.displayed = ko.observable(true);
        self.hasAudio = ko.observable(false);
        self.isRecordingLoading = ko.observable(true);
        self.showLongRunningMessage = ko.observable(false);
        self.recordingRequestError = ko.observable(false);
        self.isDeleted = ko.observable(false);
        self.hasMessages = true;
        self.messages = ko.observableArray();
        self.updatingRestoreDates = ko.observable(false);

        self.conversation = ko.isObservable(conversationObservable) ? conversationObservable : ko.observable(conversationObservable);

        var observableRecordingModels = _.map(_.filter(recordingModels, {'media': 'message'}), ko.observable);

        var messageIdToParticipantPurposeMap = self.computed(function () {
            var map = {};
            if (!self.conversation()) {
                return map;
            }

            _.each(self.conversation().participants(), function(participant) {
                if (participant.messages && participant.messages.length > 0) {
                    _.each(participant.messages, function(participantMessages) {
                        _.each(participantMessages.messages, function(message) {
                            map[message.messageId] = participant.purpose;
                        });
                    });
                }
            });
            return map;
        });

        function getParticipantPurposeForMessageId(messageId) {
            return messageIdToParticipantPurposeMap()[messageId];
        }

        self.canRestoreMessages = qualityAuth.canRestoreRecording();

        self.archivedRecordings = self.computed(function () {
            return _.filter(observableRecordingModels, function (observableModel) {
                var model = ko.unwrap(observableModel);
                return model.fileState && model.fileState.toLowerCase() === 'archived';
            });
        });

        self.restoringRecordings = self.computed(function () {
            return _.filter(observableRecordingModels, function (observableModel) {
                var model = ko.unwrap(observableModel);
                return model.fileState && model.fileState.toLowerCase() === 'restoring';
            });
        });

        self.deletedRecordings = self.computed(function () {
            return _.filter(observableRecordingModels, function (observableModel) {
                var model = ko.unwrap(observableModel);
                return model.fileState && model.fileState.toLowerCase() === 'deleted';
            });
        });

        self.restoreAllArchivedRecordings = function() {
            if (self.updatingRestoreDates()) { return; }

            var archivedRecordings = self.archivedRecordings();
            var restorePromises = _.map(archivedRecordings, function (observableRecording) {
                var recording = ko.unwrap(observableRecording);

                var opts = {};
                recording.archiveDate = moment().add(30, 'day').toISOString();
                self.updatingRestoreDates(true);
                recording.fileState = "RESTORING";
                return qualityManagementService.updateRecording(recording, opts)
                .then(function(result) {
                    observableRecording(_.assign(recording, ko.toJS(result)));
                });
            });

            Promise.all(restorePromises)
            .catch(errorCallbackFactory.createCallback({ namespace: "playback.archive.restoreRequest"}))
            .finally(function () {
                self.updatingRestoreDates(false);
            });
        };

        var collatedMessages = _.flatMap(recordingModels, function (messageModel) {
            return _.map(messageModel.messagingTranscript, function (transcript) {
                var clone = _.cloneDeep(transcript);
                clone.timestamp = new Date(transcript.timestamp);
                clone.userImages = ko.observable();

                clone.participantPurpose = getParticipantPurposeForMessageId(clone.id);
                clone.isBotParticipant = false;

                if (clone.fromUser && clone.fromUser.name) {
                    clone.username = clone.fromUser.name;
                } else if (clone.participantPurpose === 'workflow') {
                    clone.username = ko.i18n.renderString('messageDetails.workflowParticipant');
                    clone.isBotParticipant = true;
                } else if (clone.participantPurpose === 'api') {
                    clone.username = ko.i18n.renderString('messageDetails.apiParticipant');
                    clone.isBotParticipant = true;
                } else if (clone.participantPurpose === 'campaign') {
                    clone.username = ko.i18n.renderString('messageDetails.campaignParticipant');
                    clone.isBotParticipant = true;
                }

                clone.participantStyle = ko.computed(function () {
                    // Older SMS recordings don't have messageIds on the transcripts, so
                    // we can't look up the participants. For those, it is safe to assume the
                    // first one is an inbound customer, and it is not a workflow participant.
                    // Such recordings predates outbound messages and message workflows.
                    var isInternalParticipant = self.messages().length && (clone.to !== self.messages()[0].to);
                    if (clone.participantPurpose) {
                        isInternalParticipant = clone.participantPurpose === 'agent' ||
                            clone.participantPurpose === 'workflow' ||
                            clone.participantPurpose === 'api' ||
                            clone.participantPurpose === 'campaign' ||
                            clone.participantPurpose === 'user';
                    }

                    return isInternalParticipant ? 'agent' : 'customer';
                });

                if (clone.messageMediaAttachments) {
                    clone.messageMediaAttachments = _.map(clone.messageMediaAttachments, function (attachment) {
                        attachment.expandAttachment = ko.observable(true);
                        attachment.caretStyle = ko.observable('fa-caret-down');
                        attachment.toggleAttachmentVisibility = function () {
                            attachment.expandAttachment(!attachment.expandAttachment());
                            attachment.caretStyle(attachment.expandAttachment() ? 'fa-caret-down' : 'fa-caret-right');
                        };
                        return attachment;
                    });
                }

                return clone;
            });
        });

        self.messages(_.sortBy(collatedMessages, function (messageModel) {
            return messageModel.timestamp;
        }));

        var userImages = {};
        qualityBroadcast.subscribe(conversationId, BroadcastEnum.USER_IMAGES_AVAILABLE, function(message) {
            _.assign(userImages, message);
            _.each(self.messages(), function (message) {
                if (message.fromUser && message.fromUser.id) {
                    var images = userImages[message.fromUser.id];
                    message.userImages(images);
                }
            });
        });
    });

    return MessagesRecordingView;
});

